import { Box, Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../usuarios/components/ListadoUsuarios';
import {
  allUsuProfesionesAction,
  deleteUsuProfesionesAction,
  setActivoUsuProfesionesAction,
} from '../UsuProfesionesAction';
import { PARAMS_USU_PROFESIONES } from '../UsuProfesionesReducer';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoUsuProfesiones = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const usuProfesionesStore = Redux.useSelector(
    (state) => state.usuProfesiones,
  );
  const usuariosStore = Redux.useSelector((state) => state.usuarios);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...usuProfesionesStore.params,
        idUsuario: usuariosStore.activo.id,
      };
      dispatch({ type: PARAMS_USU_PROFESIONES, payload });
      await allUsuProfesionesAction(dispatch, payload);
    };
    return fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const rowsData = [];
    usuProfesionesStore.all.forEach((el) =>
      rowsData.push({
        ...el,
        nombre: el.profesion.nombre,
        estatus: el.estatus,
        actions: el,
      }),
    );
    setRows(rowsData);
  }, [usuProfesionesStore.all]);

  const _handleEditClick = async (id) => {
    const data = usuProfesionesStore.all.find((el) => el.id === id);
    await setActivoUsuProfesionesAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteUsuProfesionesAction(
      { dispatch, notify },
      usuProfesionesStore.activo.id,
      usuProfesionesStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.oficio.name,
      label: CONST.oficio.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Tooltip
                describeChild
                title="Estatus del registro"
                placement="left"
              >
                <Chip
                  label={value.nombre}
                  size="small"
                  color={value.id === 1 ? 'success' : 'error'}
                />
              </Tooltip>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box sx={{ width: '70px' }}>
              <Stack direction="row">
                <ActionsListWidget
                  id={value.id}
                  onEdit={async () => {
                    await setActivoUsuProfesionesAction(dispatch, value);
                    setOpenModalForm(true);
                  }}
                  onDelete={async () => {
                    await setActivoUsuProfesionesAction(dispatch, value);
                    setOpenModalDelete(true);
                  }}
                />
              </Stack>
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={usuProfesionesStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {usuProfesionesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {usuProfesionesStore.activo.profesion.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoUsuProfesiones;
